import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';

const AuditLog = withInject({
  AuditLog: 'AuditLogCrate.components.AuditLog'
})(({ AuditLog: AL }: any) => <AL />);

export const Route = createFileRoute('/_secured/administration/account/audit-log/$page/$limit')({
  component: AuditLog,
});
